// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"22483eb5","608":"9aecaf08"}[chunkId] + ".chunk.css";
};